import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

interface CategoryData {
  category: string;
  totalOsCount: number;
  avgTicket: number;
  trend: 'up' | 'stable' | 'down';
}

interface VehicleData {
  make: string;
  model: string;
  osCount: number;
  percentage: number;
}

interface CoverageGap {
  category: string;
  osCount: number;
  activeCampaigns: number;
}

interface SeasonalityData {
  month: string;
  category: string;
  osCount: number;
}

export interface MarketIntelligenceData {
  topCategories: CategoryData[];
  topVehicles: VehicleData[];
  coverageGaps: CoverageGap[];
  seasonality: SeasonalityData[];
}

export interface Opportunity {
  category: string;
  region?: string;
  osCount: number;
  avgTicket: number;
  trend: 'up' | 'stable' | 'down';
  growthPercent: number;
  suggestedBudget: number;
  topModels: string[];
  priority: 'red' | 'orange' | 'yellow';
}

interface OpportunitiesData {
  opportunities: Opportunity[];
}

export function useMarketIntelligence() {
  return useQuery<MarketIntelligenceData>({
    queryKey: ['market-intelligence'],
    queryFn: async () => {
      const res = await api.get('/partners/my/market-intelligence');
      return res.data;
    },
    staleTime: 30 * 60 * 1000, // 30 min (server caches 1h)
  });
}

export function useOpportunities() {
  return useQuery<OpportunitiesData>({
    queryKey: ['market-opportunities'],
    queryFn: async () => {
      const res = await api.get('/partners/my/opportunities');
      return res.data;
    },
    staleTime: 30 * 60 * 1000,
  });
}
